module.exports = ".btn-primary {\n  color: #cc3333;\n  border: 2px solid #cc3333;\n  background-color: #fff;\n  font-weight: bold; }\n"